/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:50
 */
import Column from "./Column";

class StringColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

}

export default StringColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/columns/StringColumn.js